/**
 * Region normalisation utilities.
 *
 * Onboarding stores country as the full label ("United Kingdom", "United States",
 * "India", etc.) because that's what the dropdown shows. The API/filter layer uses
 * short codes (UK / US / IN). This helper keeps the mapping in one place so the
 * Dashboard + HomePage + future screens stay in sync.
 */

/**
 * Resolve a user's onboarding country to the short code used by the app's
 * region chips and API filters.
 *
 * @param {object} user
 * @returns {'UK' | 'US' | 'IN' | 'all'} — 'all' when country is unknown / not mapped.
 */
export function getDefaultRegion(user) {
  const raw = (user?.preferences?.country || user?.country || '').trim().toLowerCase();
  if (!raw) return 'all';
  if (raw === 'uk' || raw === 'gb' || raw.includes('united kingdom') || raw === 'britain' || raw === 'great britain') return 'UK';
  if (raw === 'us' || raw === 'usa' || raw.includes('united states') || raw === 'america') return 'US';
  if (raw === 'in' || raw.includes('india')) return 'IN';
  return 'all';
}

/**
 * Same mapping as getDefaultRegion, but returns undefined instead of 'all' so the
 * result can be passed directly as a query-string param (undefined gets omitted by
 * axios/fetch).
 */
export function getRegionParam(user) {
  const r = getDefaultRegion(user);
  return r === 'all' ? undefined : r;
}
